/* eslint-disable */
import * as axios from 'axios';
import { flow } from 'lodash';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

import store from '../store';

const initClient = () => {
  let a = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {},
    cancelToken: source.token,
  });

  a.interceptors.request.use(config => flow([
    (config) => {
      config.headers.common.Authorization = `Bearer ${store.state.auth.token}`;

      return config;
    },
  ])(config));

  return a;
}

export const http = initClient();
export const silentClient = initClient();

http.interceptors.response.use(response => {
  return Promise.resolve(response);
}, (error) => {
  if (axios.isCancel(error)) {
    store.dispatch('setErrorMessage', error.message);
  } else if (error.response.data.hasOwnProperty('message')) {
    console.log([error])
    store.dispatch('setErrorMessage', error.response.data.message);
  }
  return Promise.reject(error);
});

export const cancellableRequest = (method, clientInstance = http) =>
  (endpoint, params = {}) => {
    const req = clientInstance.request({
      url: endpoint,
      method,
      data: params,
    });

    if (store.state.isOfflineMode) {
      source.cancel('Functionality not allowed while offline.');
    }

    return req;
  }


export const get = (endpoint, params = {}) => http.get(endpoint, params);
export const post = cancellableRequest('post');
export const put = cancellableRequest('put');
export const del = cancellableRequest('delete');



// WEBPACK FOOTER //
// ./src/services/http.js